import React from 'react';
import ShoppingCart from '../components/ShoppingCart';

const Cart = () => {
  return <ShoppingCart />;
};

export default Cart;
